import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType, ReturnPaymentType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Loan } from 'src/app/models/loan';
import { Order } from 'src/app/models/order';
import { InvoiceRequestModel } from 'src/app/models/request/InvoiceRequestModel';
import { ReturnTransactionContractRequestModel } from 'src/app/models/request/return-transaction-contract-request-model';
import { ReturnTransactionRequest } from 'src/app/models/request/return-transaction-request';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';
import { ParamsService } from 'src/app/services/params.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-credit-return-invoice-stepper',
  templateUrl: './create-credit-return-invoice-stepper.component.html',
  styleUrls: ['./create-credit-return-invoice-stepper.component.sass']
})
export class CreateCreditReturnInvoiceStepperComponent implements OnInit {

  order: Order = new Order();
  loans: Array<Loan> = [];
  loanForms: FormArray = new FormArray([]);
  constructor(private route: ActivatedRoute, private orderSerivce: OrderService,
    private configService: ConfigurationService,
    private confirmService: PosConfirmationService,
    private paramsService: ParamsService,
    private invoiceService: InvoiceService,
    private toastr: ToastrService,
    private router: Router,
    private readonly exceptionSolutionService: ExceptionSolutionService
  ) { }

  async ngOnInit(): Promise<void> {
    let orderComplete = (await this.orderSerivce.readerOrderCompleteProcess(this.route.snapshot.params.code).toPromise()).response;
    this.order = orderComplete.order;
    if (!this.order.originalExternalInvoices) {
      let originalOrderComplete = (await this.orderSerivce.readerOrderCompleteProcess(this.order.originalOrderCode).toPromise()).response;
      this.loans = originalOrderComplete.loans.filter(f => f.invoices.some(s => s.invoiceCode == this.order.invoiceNumber));
    }

    this.loans.filter(f => f.contractNumber).forEach((loan, i) => {
      this.loanForms.insert(i, new FormGroup({
        'contractNumber': new FormControl(loan.contractNumber),
        'isReturned': new FormControl(loan.contractCanceled, [Validators.required])
      }));

      if (loan.contractCanceled == "X") {
        this.loanForms.at(i).markAsDirty();
        this.loanForms.at(i).markAsTouched();
      }
    })
  }

  getLoanForm(index: number) {
    return this.loanForms.at(index) as FormGroup;
  }
  async return(type: ReturnPaymentType) {
    const returnMaxCash = (await this.paramsService.readParam("returns-max-cash").toPromise()).response;

    if (this.order.totals.netTotal >= Number(returnMaxCash.value) && type == ReturnPaymentType.CASH) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución`, `El monto de la devolución sobrepasa el limite de efectivo ${returnMaxCash.value}`);
    }
    let confirmRresult = await this.confirmService.showAsync("Devolución de Factura", `¿Esta seguro de completar el proceso de devolucion para esta orden?`, ModalDialogType.SUCCESS);

    if (!confirmRresult) {
      return;
    }

    let transaction = new ReturnTransactionRequest();
    transaction.orderCode = this.order.code;
    transaction.branchCode = this.order.branchCode;
    transaction.salesOrgCode = this.order.salesOrgCode;
    transaction.registerCode = this.configService.readRegister().code;
    transaction.paymentType = type;
    transaction.contractRequestModels = this.loans.map(m => {
      let result = new ReturnTransactionContractRequestModel();
      result.contractNumber = m.contractNumber;
      result.administrationSurcharge = 0;
      return result;
    });

    transaction.invoiceDetails = this.order.orderEntryList.map(m => {
      let result = new InvoiceRequestModel();
      result.orderEntryCode = m.code;
      result.quantity = m.totalQuantity;
      return result;
    });
    transaction.voidOrderOperationType = this.route.snapshot.params.operation;
    let result = (await this.invoiceService.processReturnTransction(transaction).toPromise()).response.invoice;

    if (result.fullNumber) {
      Swal.fire({
        title: `Devolución`,
        html: `Se ha generado la nota de crédito ${result.fullNumber} con exito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
      this.router.navigate(["returnInvoices", this.order.code], { queryParams: { print: true } });
    }
  }
}
